export default __webpack_public_path__ + "static/media/arrow.be727635.svg";